// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1ftAK","item":"PaymentsMobile_item__VHaed","label":"PaymentsMobile_label__1t6uz","amount":"PaymentsMobile_amount__1M5ul"};